import { ToastProps } from '../jdstoast/interface';

interface ToastContainerProps {
  toasts: ToastProps[];
  onShow?: (id: string) => void;
  onClose?: (id: string) => void;
}

export const withLogic =
  (
    Component: React.ComponentType<ToastContainerProps>
  ): React.FC<ToastContainerProps> =>
  (props: ToastContainerProps) => {
    return (
      <Component
        {...{
          ...props,
          activeToasts: props.toasts.map((t) => ({
            ...t,
            prefix: t.prefix || t.icon
          }))
        }}
      />
    );
  };
